import { isNone } from '@ember/utils';
import { EventsType } from 'cio/utils/analytics/events';
import ImportModel from 'cio/models/import';

export enum ExportType {
  Original = 'original',
  Warnings = 'warnings',
  Errors = 'errors',
  Import = 'import',
}

export const EVENT_NAMES: Record<ExportType, keyof EventsType['import']> = {
  [ExportType.Original]: 'original_file_exported',
  [ExportType.Warnings]: 'warnings_file_exported',
  [ExportType.Errors]: 'errors_file_exported',
  [ExportType.Import]: 'preview_file_exported',
};

export default function constructExportURL(type: ExportType, record: ImportModel) {
  if (isNone(record)) {
    return null;
  }

  let { id, validateMeta } = record;

  if (type === ExportType.Original) {
    return id ? `imports/download/original/${id}` : null;
  }

  if (type === ExportType.Import) {
    return id ? `imports/download/import/${id}` : null;
  }

  if (type === ExportType.Warnings) {
    if (validateMeta == null) {
      return null;
    }

    let exportId = validateMeta.warningExport;
    return exportId ? `exports/${exportId}/download` : null;
  }

  if (type === ExportType.Errors) {
    if (validateMeta == null) {
      return null;
    }

    let exportId = validateMeta.invalidExport;
    return exportId ? `exports/${exportId}/download` : null;
  }

  return null;
}
